export default "__VITE_ASSET__KQqMyL2V__"